require('./fullPageRedactionStyle.less');

var RedactionNoteView = require('./view'),
    ZonePropertiesView = require('../../../../canvas/views/shape/redaction/dialog/fullPageRedaction/view');


module.exports = RedactionNoteView.extend({

    initialize: function() {

        RedactionNoteView.prototype.initialize.apply( this, arguments );

        this.zonePropertiesView = null;

    },


    templateHelpers: _.extend( {}, RedactionNoteView.prototype.templateHelpers, {

        isFullPageRedaction: function() {
            return true;
        }

    }),

    ui: _.extend( {}, RedactionNoteView.prototype.ui, {

        zonePropertiesDialogHolder:     '.note-fpr-zone-props-wr'

    }),

    onRender: function() {

        RedactionNoteView.prototype.onRender.apply( this, arguments );

        this.renderZonePropertiesView();

    },

    /**
     * Treat this like a region.  Should refactor note view to be a LayoutView.
     */
    renderZonePropertiesView: function() {

        var shapeModel = this.model.getShape();

        this.zonePropertiesView && this.zonePropertiesView.destroy();

        this.zonePropertiesView = new ZonePropertiesView({
            shapeModel: shapeModel
        });

        this.ui.zonePropertiesDialogHolder.append(
            this.zonePropertiesView.render().el
        );

    },

    toggleExpandMode: function() {

        RedactionNoteView.prototype.toggleExpandMode.apply( this, arguments );

        this.renderZonePropertiesView();

    },

    onBeforeDestroy: function() {

        this.zonePropertiesView.destroy();

        RedactionNoteView.prototype.onBeforeDestroy.apply( this, arguments );

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/redaction/fullPageRedaction.js
 ** module id = 312
 ** module chunks = 0
 **/